<template>
    <div class="survey overflow_hidden">
        <div class="box fl bg_F6F6F6" v-if="role==='admin'||role==='agent'">
            <h3 class="title txt_black65 f24 bold500">我的设备</h3>
            <div class="fl txt_black65 bold400 f16">总数量： <span v-text="device.all"></span></div>
            <div class="fl txt_black65 bold400 f16">正常数： <span v-text="device.normal"></span></div>
            <div class="fl txt_black65 bold400 f16">离线数： <span v-text="device.offline"></span></div>
            <div class="fl txt_black65 bold400 f16">停用数： <span v-text="device.deactivate"></span></div>
        </div>

        <div class="box fl bg_F6F6F6">
            <h3 class="title txt_black65 f24 bold500">账户资金</h3>
            <div class="fl">今天流水收益：<span v-text="fund.todayAmount"></span>元</div>
            <div class="fl">今天实际收益：<span v-text="fund.todayReal"></span>元</div>
            <div class="fl">最近一月流水收益： <span v-text="fund.all"></span>元</div>
            <div class="fl">最近一月实际收益： <span v-text="fund.allReal"></span>元</div>
            <div class="fl">可提现余额： <span v-text="fund.withdrawAmount"></span>元</div>
            <div class="fl" @click="withdrawal" v-if="role==='partner'"><span class="cursor_pointer txt_4673E3">申请提现</span></div>
<!--            <div class="fl" @click="exportStatement"><span class="cursor_pointer txt_4673E3">导出流水报表</span></div>-->
<!--            <div class="fl" @click="exportEarnings"><span class="cursor_pointer txt_4673E3">导出收益报表</span></div>-->
        </div>

<!--        <div class="box fl bg_F6F6F6" v-if="role==='admin'">-->
<!--            <h3 class="title txt_black65 f24 bold500">我的用户</h3>-->
<!--            <div class="fl tc txt_black65 bold400 f16">-->
<!--                <div><img src="/data/manage/images/comm/ren.png" alt=""/></div>-->
<!--                <div>用户总量</div>-->
<!--                <div v-text="user.num_all"></div>-->
<!--            </div>-->
<!--            <div class="fl tc txt_black65 bold400 f16">-->
<!--                <div><img src="/data/manage/images/comm/dayz.png" alt=""/></div>-->
<!--                <div>新增用户</div>-->
<!--                <div v-text="user.num_add"></div>-->
<!--            </div>-->
<!--            <div class="fl tc txt_black65 bold400 f16">-->
<!--                <div><img src="/data/manage/images/comm/huo.png" alt=""/></div>-->
<!--                <div>活跃用户</div>-->
<!--                <div v-text="user.num_active"></div>-->
<!--            </div>-->
<!--        </div>-->
        <withdrawal-amount ref="withdrawalAmount"></withdrawal-amount>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import WithdrawalAmount from './withdrawalAmount'
    export default {
        name: "survey",
        components: {
            WithdrawalAmount
        },
        computed: {
            ...mapGetters({
                role: 'user/role'
            }),
        },
        data() {
          return {
              device: {
                  all: '',
                  deactivate: '',
                  normal: '',
                  offline: '',
              },
              fund: {
                  all: '',
                  allReal: '',
                  todayAmount: '',
                  todayReal: '',
                  withdrawAmount: ''
              },
              user: {
                  num_all: '',
                  num_add: '',
                  num_active: ''
              }
          }
        },
        methods: {
            init() {
                this.getDevice();
                this.getFund();
                // this.getUser();
            },
            getDevice() {
                this.$api.get('/manage/survey/device').then((data) => {
                    this.device = data;
                }).catch((error) => {
                    this.$alert.error({content: '获取设备信息出错'});
                });
            },
            getFund() {
                this.$api.get('/manage/survey/fund').then((data) => {
                    this.fund = data;
                }).catch((error) => {
                    this.$alert.error({content: '获取账户资金信息出错'});
                });
            },
            withdrawal() {
                if(this.fund.withdrawAmount > 0) {
                    this.$refs.withdrawalAmount.init(this.fund.withdrawAmount);
                }else {
                    this.$modal({content: '你可提现的金额不足'});
                }
            },
            getUser() {
                this.$api.get('/manage/survey/user').then((data) => {
                    this.user = data;
                }).catch((error) => {
                    this.$alert.error({content: '获取账户资金信息出错'});
                });
            },
            exportStatement() {
                this.$api.post('/manage//manage/survey/export_statement',).then((data) => {
                    let array = data.path.split('.');
                    let suffix = array[array.length-1];
                    let downloadElement = document.createElement('a');
                    downloadElement.href = 'https://manage.scadkj.com/' + data.path;
                    downloadElement.download = '流水报表' + '.' + suffix;
                    downloadElement.style.display = 'none';
                    document.body.appendChild(downloadElement);
                    downloadElement.click();
                    document.body.removeChild(downloadElement);
                }).catch((error) => {
                    this.$alert.error({content: '导出流水报表出错:' + error});
                })
            },
            exportEarnings() {
                this.$api.post('/manage//manage/survey/export_earnings',).then((data) => {
                    let array = data.path.split('.');
                    let suffix = array[array.length-1];
                    let downloadElement = document.createElement('a');
                    downloadElement.href = 'https://manage.scadkj.com/' + data.path;
                    downloadElement.download = '收益报表' + '.' + suffix;
                    downloadElement.style.display = 'none';
                    document.body.appendChild(downloadElement);
                    downloadElement.click();
                    document.body.removeChild(downloadElement);
                }).catch((error) => {
                    this.$alert.error({content: '导出收益报表出错:' + error});
                })
            }
        }
    }
</script>

<style scoped>
    .survey {
        width: 1125px;
        padding-top: 40px;
    }

    .survey > .box {
        width: 500px;
        height: 250px;
        margin: 0 0 40px 40px;
        filter: progid:DXImageTransform.Microsoft.Shadow(color=#909090, direction=120, strength=4);
        -moz-box-shadow: 2px 2px 10px #909090;
        -webkit-box-shadow: 2px 2px 10px #909090;
        box-shadow: 2px 2px 10px #909090;
    }

    .survey > .box > .title {
        margin: 10px 0 0 20px;
    }

    .survey > .box > div {
        width: 50%;
    }

    .survey > .box:nth-of-type(1) > div {
        margin-top: 40px;
    }

    .survey > .box:nth-of-type(1) > div:nth-of-type(2n+1) {
        padding-left: 50px;
    }

    .survey > .box > :nth-of-type(1):nth-of-type(2n+2) {
        padding-left: 20px;
    }

    .survey > .box:nth-of-type(2) > div {
        margin-top: 30px;
    }

    .survey > .box:nth-of-type(2) > div {
        padding-left: 50px;
    }

    .survey > .box:nth-of-type(3) > div {
        width: 33.33333%;
        padding: 40px 0;
    }

    .survey > .box:nth-of-type(3) > div > div:nth-of-type(2) {
        margin: 10px 0;
    }
</style>
